var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tab-item",class:{ active: _vm.active, disabled: _vm.disabled },on:{"click":function($event){!_vm.disabled && _vm.$emit('click', $event)}}},[_c('a',{attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }